import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store/index";
import ApiAlbum from "@/api/ApiAlbum";

import {
  HomeMultimediaAlbumListResponse,
  HomeMultimediaAlbumResponse,
  HomeMultimediaListResponse,
  HomeMultimediaResponse,
} from "@API/src/component/memoruHome/album/types";
import {
  FetchAlbumListRequest,
  FetchAlbumRequest,
  FetchMultimediaListRequest,
  FetchMultimediaRequest,
  FetchMultimediaPurchasedRequest,
} from "@/model/request/album";

export interface AlbumState {
  albums: HomeMultimediaAlbumListResponse | null;
  album: HomeMultimediaAlbumResponse | null;
  multimedias: HomeMultimediaListResponse | null;
  multimedia: HomeMultimediaResponse | null;
  myPhotos: HomeMultimediaListResponse | null;
}

@Module({ dynamic: true, store, name: "album", namespaced: true })
class AlbumModule extends VuexModule implements AlbumState {
  public albums: HomeMultimediaAlbumListResponse | null = null;
  public album: HomeMultimediaAlbumResponse | null = null;
  public multimedias: HomeMultimediaListResponse | null = null;
  public multimedia: HomeMultimediaResponse | null = null;
  public myPhotos: HomeMultimediaListResponse | null = null;

  @Action({ rawError: true })
  public async fetchAlbumList(request: FetchAlbumListRequest) {
    const response: HomeMultimediaAlbumListResponse =
      await ApiAlbum.fetchAlbumList(request);
    this.setAlbums(response);
    return response;
  }

  @Mutation
  public setAlbums(albums: HomeMultimediaAlbumListResponse) {
    this.albums = albums;
  }

  @Action({ rawError: true })
  public async fetchAlbum(request: FetchAlbumRequest) {
    const response: HomeMultimediaAlbumResponse = await ApiAlbum.fetchAlbum(
      request
    );
    return response;
  }

  @Mutation
  public setAlbum(album: HomeMultimediaAlbumResponse) {
    this.album = album;
  }

  @Action({ rawError: true })
  public async fetchMultimediaList(request: FetchMultimediaListRequest) {
    const response: HomeMultimediaListResponse =
      await ApiAlbum.fetchMultimediaList(request);
    // skipが 0の場合は初期データ、それ以外は追加データ
    if (request.skip === 0) {
      this.setMultimedias(response);
    } else {
      this.appendMultimedias(response);
    }

    return response;
  }

  @Mutation
  public setMultimedias(multimedias: HomeMultimediaListResponse) {
    this.multimedias = multimedias;
  }

  @Action({ rawError: true })
  public async fetchMultimedia(request: FetchMultimediaRequest) {
    const response: HomeMultimediaResponse = await ApiAlbum.fetchMultimedia(
      request
    );
    return response;
  }

  @Mutation
  public setMultimedia(multimedia: HomeMultimediaResponse) {
    this.multimedia = multimedia;
  }

  @Mutation
  public appendMultimedias(newMultimedias: HomeMultimediaListResponse) {
    if (this.multimedias && newMultimedias) {
      // 既存のitemsに新しいitemsを追加
      //this.multimedias.items = [...this.multimedias.items, ...newMultimedias.items];
      this.multimedias.items = newMultimedias.items;
      console.log('this.multimedias.items:', this.multimedias.items)
      // totalは新しいtotalで更新
      this.multimedias.total = newMultimedias.total;
      console.log('this.multimedias.total:', this.multimedias.total)
    } else if (newMultimedias) {
      // myPhotosがnullの場合は新しいデータを設定
      console.log("myPhotosがnullの場合は新しいデータを設定")
      this.multimedias = newMultimedias;
    }
  }

  @Action({ rawError: true })
  public async fetchMultimediaPurchased(request: FetchMultimediaPurchasedRequest) {
    const response: HomeMultimediaListResponse = await ApiAlbum.fetchMultimediaPurchased(
      request
    );
    
    // skipが 0の場合は初期データ、それ以外は追加データ
    if (request.skip === 0) {
      this.setMyPhotos(response);
    } else {
      this.appendMyPhotos(response);
    }
    
    return response;
  }

  @Mutation
  public setMyPhotos(myPhotos: HomeMultimediaListResponse) {
    this.myPhotos = myPhotos;
  }

  @Mutation
  public appendMyPhotos(newPhotos: HomeMultimediaListResponse) {
    if (this.myPhotos && newPhotos) {
      // 既存のitemsに新しいitemsを追加
      this.myPhotos.items = [...this.myPhotos.items, ...newPhotos.items];
      console.log('this.myPhotos.items:', this.myPhotos.items)
      // totalは新しいtotalで更新
      this.myPhotos.total = newPhotos.total;
      console.log('this.myPhotos.total:', this.myPhotos.total)
    } else if (newPhotos) {
      // myPhotosがnullの場合は新しいデータを設定
      console.log("myPhotosがnullの場合は新しいデータを設定")
      this.myPhotos = newPhotos;
    }
  }
}

export const albumModule = getModule(AlbumModule);
